import { useCallback, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { setHasItemExceedingStock } from '../../slices/shoppingBag';

import { useHasItemExceedingStock } from './useHasItemExceedingStock';

type ReturnType = [boolean, (v: boolean) => void];

function useHandleItemExceedingStockUpdate(): ReturnType {
  const hasItemExceedingStock = useHasItemExceedingStock();
  const dispatch = useDispatch();
  const setIsContinueDisabled = useCallback(
    (val: boolean) => {
      dispatch(setHasItemExceedingStock({ hasItemExceedingStock: val }));
    },
    [dispatch]
  );
  return [hasItemExceedingStock, setIsContinueDisabled];
}

export function useItemExceedingStockCheck(
  nowHasItemExceedingStock: boolean
): void {
  const [hasItemExceedingStock, setIsContinueDisabled] =
    useHandleItemExceedingStockUpdate();
  useEffect(() => {
    if (nowHasItemExceedingStock !== hasItemExceedingStock) {
      setIsContinueDisabled(nowHasItemExceedingStock);
    }
  }, [hasItemExceedingStock, nowHasItemExceedingStock, setIsContinueDisabled]);
}
